import { useEffect, useState } from "react";

function yearsSince(startDate) {
  const today = new Date();
  const anniversary = new Date(`${startDate}T00:00:00`);
  let years = today.getFullYear() - anniversary.getFullYear();

  if (
    today.getMonth() < anniversary.getMonth() ||
    (today.getMonth() === anniversary.getMonth() &&
      today.getDate() < anniversary.getDate())
  ) {
    years -= 1;
  }

  return years;
}

const bootLines = [
  "AMBEX 9000 BIOS v2.3.1 — (C) 1988",
  "",
  "RUNNING POST...",
  "  CHECKING MEMORY......... 640K OK",
  `  DETECTING CAREER........ ${yearsSince("2020-01-13")} YEARS OK`,
  "  MOUNTING /usr/prince_motsumi OK",
  "",
  "> boot sequence complete",
  "> welcome_",
];

function BootSequence({ onComplete, poweredOn }) {
  const [output, setOutput] = useState("");

  useEffect(() => {
    if (!poweredOn) return undefined;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    let timeoutId;
    let lineIndex = 0;
    let charIndex = 0;

    if (reducedMotion) {
      setOutput(bootLines.join("\n"));
      onComplete();
      return undefined;
    }

    setOutput("");
    const typeLine = () => {
      if (lineIndex >= bootLines.length) {
        timeoutId = window.setTimeout(onComplete, 400);
        return;
      }

      const line = bootLines[lineIndex];
      const typeCharacter = () => {
        if (charIndex <= line.length) {
          setOutput(
            bootLines.slice(0, lineIndex).join("\n") +
              (lineIndex > 0 ? "\n" : "") +
              line.slice(0, charIndex),
          );
          charIndex += 1;
          timeoutId = window.setTimeout(
            typeCharacter,
            line.startsWith("  ") ? 4 : 14,
          );
        } else {
          lineIndex += 1;
          charIndex = 0;
          timeoutId = window.setTimeout(typeLine, line === "" ? 60 : 140);
        }
      };

      typeCharacter();
    };

    typeLine();
    return () => window.clearTimeout(timeoutId);
  }, [onComplete, poweredOn]);

  return <pre className="boot-sequence">{output}</pre>;
}

export default BootSequence;
